<div class="message">
    <img class="logo" src="assets/images/hey-coach-logo-splash.png" alt="Rollit">
    <img class="loader" src="assets/icons/loading-icon.svg" alt="Loading">
</div>
<div [ngClass]="{'photo':photoIsVisible}" [ngStyle]="{backgroundImage:'url(/assets/images/' + mediaSizeIsDesktop + '-splash-' + randomNumber + '.jpg'}">

</div>
